import api from "./api";

export const getSystemBattery = async () => {
  const res = await api.get("/apis/system_battery");
  return res.data;
};

export const getAccountabilityDashboard = async (value) => {
  const res = await api.get("apis/accountability_dashboard", {
    params: { option: value },
  });
  return res.data;
};

// export const getFlowHealth = async () => {
//   const res = await api.get("/apis/flow_health");
//   return res.data;
// };
export const getFlowHealth = async (category) => {
  const res = await api.get("/apis/flow_health", {
    params: category && category !== "ALL" ? { Category: category } : {},
  });

  return res.data;
};

export const getSystemUsage = async (days) => {
  const res = await api.get(`apis/system_usage`, {
    params: {
      option: days,
    },
  });
  return res.data;
};

export const getTrendData = async (option, start, end, startWeek, endWeek) => {
  const params = {
    option_value: option,
    start,
    end,
  };

  // Keep existing week params for other filters only
  // Quarter API needs only: option_value, start, end
  if (option !== "Quarter") {
    params.start_week = startWeek ?? "undefined";
    params.end_week = endWeek ?? "undefined";
  }

  const res = await api.get(`apis/trend`, { params });
  return res.data;
};

// 2. Fetch Individual Account/Meter Trend Data
// export const getAccountTrend = async (
//   option,
//   start,
//   end,
//   startWeek,
//   endWeek,
//   meterIds,
// ) => {
//   const res = await api.get(`apis/account_trend`, {
//     params: {
//       option_value: option,
//       start,
//       end,
//       start_week: startWeek,
//       end_week: endWeek,
//       meterid: JSON.stringify(meterIds), // API expects a JSON string of IDs
//     },
//   });
//   return res.data;
// };

export const getAccountTrend = async (
  option,
  start,
  end,
  startWeek,
  endWeek,
  meterIds,
) => {
  const params = {
    option_value: option,
    start,
    end,
    meterid: JSON.stringify(meterIds),
  };

  if (option !== "Quarter") {
    params.start_week = startWeek;
    params.end_week = endWeek;
  }

  const res = await api.get(`apis/account_trend`, { params });
  return res.data;
};

export const getTrendDownloadData = async (option, start, end, district) => {
  const res = await api.get(`apis/download_trend`, {
    params: { option_value: option, start, end, district },
  });
  return res.data;
};
export const getDownloadAccountTrend = async (option, start, end, meterIds) => {
  const res = await api.get("apis/download_account_trend", {
    params: {
      option_value: option,
      start: start,
      end: end,
      start_week: undefined, // Matches your requested URL structure
      end_week: undefined,
      meterid: JSON.stringify(meterIds), // Encodes ["288433-"]
    },
  });
  return res.data;
};

export const getAccountOverrideSelect = async (selectedIds) => {
  const res = await api.get("apis/meter/account_override/select", {
    params: {
      selected: JSON.stringify(selectedIds), // Encodes ["429700"]
    },
  });
  return res.data;
};

export const getAccountOverrideList = async () => {
  const res = await api.get("apis/account/overide_name/select/list");
  return res.data;
};
export const getTwinStats = async () => {
  const res = await api.get("/apis/meter_stat_operational/count");
  return res.data;
};
// Account settings apis
export const getAdminSettingsList = async (district) => {
  const res = await api.get(`apis/admin_settings/all_list`, {
    params: { district }, // remove if API does not require district
  });
  return res.data;
};

// ✅ CREATE
export const createSettingsParameters = async (data) => {
  try {
    const res = await api.post("apis/admin_settings", data);
    console.log("Create Admin Setting Response:", res);
    return res.data;
  } catch (error) {
    console.error("Error creating admin setting:", error);
    throw error;
  }
};

export const deleteAdminSetting = async (id) => {
  console.log("deleteid", id);
  const res = await api.delete(`apis/admin_settings/${id}`);
  return res.data;
};

export const editAdminSetting = (id, payload) => {
  console.log("editidddd", id);
  return api.put(`apis/admin_settings_edit/${id}`, payload);
};

export const getUserList = async (district) => {
  try {
    // GET request to fetch user data from the API endpoint, passing the district parameter
    const res = await api.get("apis/user_list", {
      params: { district }, // Include district in the API request
    });
    // console.log("User List Response:", res);
    return res.data; // Assuming the response contains an array of users
  } catch (error) {
    console.error("Error fetching user list:", error);
    throw error; // Propagate error if needed
  }
};

export const getOverrideAccountsList = async () => {
  try {
    // If district is not required, just call the API without params
    const res = await api.get("apis/account/overide_name/list");

    // console.log("Override Name List Response:", res);
    return res.data;
  } catch (error) {
    console.error("Error fetching override name list:", error);
    throw error;
  }
};

export const getMeterManagement = async () => {
  try {
    // If district is not required, just call the API without params
    const res = await api.get("apis/account_based_meter_log_list");

    return res.data;
  } catch (error) {
    console.error("Error fetching meter management data:", error);
    throw error;
  }
};

// meterhistory

export const getChangeLog = () => {
  return api.get("apis/changelog");
};

export const getEntityChangeLog = (entityType, pk) => {
  console.log("Fetching changelog for entity:", entityType, "with PK:", pk);
  return api.get(`apis/changelog/entity?entity_type=${entityType}&pk=${pk}`);
};

export const getTwinMeter = async ({
  page = 1,
  page_limit = 50,
  active = "all",
}) => {
  const res = await api.get("/apis/meter_list", {
    params: { page, page_limit, active },
  });
  return res.data;
};
// --- Meters By Flow APIs (New Integration) ---

/**
 * Fetch the list of meters categorized by flow
 * @param {string} option - 'Day', 'Week', 'Hour', etc.
 * @param {string} rangeOption - 'Past Month', 'Past Week', etc.
 * @param {string|number} userId - The current user ID
 * @param {string} start - Custom start date (optional)
 * @param {string} end - Custom end date (optional)
 */
export const getMetersByFlowList = async (
  option,
  rangeOption,
  userId,
  start,
  end,
) => {
  const res = await api.get(`apis/water/aggregate/by_flow/meter_list`, {
    params: {
      option,
      range_option: rangeOption,
      user_id: userId,
      start: start || undefined,
      end: end || undefined,
    },
  });
  return res.data;
};

/**
 * Fetch chart trend data for selected meters
 * @param {string} option - 'Day', 'Week', 'Hour', etc.
 * @param {string} rangeOption - 'Past Month', 'Past Week', etc.
 * @param {number} interval - Numerical interval (1, 2, etc.)
 * @param {Array} selectedMeters - Array of objects [{code, meters: []}]
 * @param {string} start - Custom start date (optional)
 * @param {string} end - Custom end date (optional)
 */
export const getMetersByFlowChart = async (
  option,
  rangeOption,
  interval,
  selectedMeters,
  start,
  end,
) => {
  const res = await api.post(
    `apis/water/aggregate/by_flow`,
    { selected_meters: selectedMeters }, // Request Body
    {
      params: {
        option,
        range_option: rangeOption,
        interval,
        start: start || undefined,
        end: end || undefined,
      },
    },
  );
  return res.data;
};

export const getAggregateAccount = async (
  option,
  rangeOption,
  interval,
  selected,
) => {
  const res = await api.get(`apis/water/aggregate/account`, {
    params: {
      option,
      range_option: rangeOption,
      interval,
      selected: JSON.stringify(selected), // API expects a JSON string of account names
    },
  });
  return res.data;
};

/**
 * Fetch aggregate data by Category (POST)
 */
export const getAggregateCategory = async (
  option,
  rangeOption,
  interval,
  paramsDatas,
) => {
  const res = await api.post(`apis/water/aggregate/category`, paramsDatas, {
    params: {
      option,
      range_option: rangeOption,
      interval,
    },
  });
  return res.data;
};

/**
 * Fetch user-specific color preferences
 */
export const getUserColors = async (userId) => {
  const res = await api.get(`apis/user_color`, {
    params: { user_id: userId },
  });
  return res.data;
};
// Ouliners

// Change all Outlier services to this pattern:
export const getOutliers = async (params) => {
  const res = await api.get(`apis/outliers/new`, {
    params: params, // This passes everything: option, minimum_score, start_date, end_date, etc.
  });
  return res.data;
};

export const getOutliersByMeter = async (params) => {
  const res = await api.get(`apis/outliers_by_meter/new`, {
    params: params,
  });
  return res.data;
};

export const getOutliersOverTime = async (params) => {
  const res = await api.get(`apis/outliers_time/new`, {
    params: params,
  });
  return res.data;
};

export const getOutliersCount = async (params) => {
  const res = await api.get(`apis/outliers_count/new`, {
    params: params,
  });
  return res.data;
};
// Notification
export const getNotificationStatusList = async ({ user_id, district }) => {
  const res = await api.get("/apis/notification_status_list", {
    params: { user_id, district },
  });
  return res.data;
};

//Reports and alerts
export const getNotificationMeterSettingsList = async (userId) => {
  const res = await api.get(`/apis/notification_meter_settings_list`, {
    params: { user_id: userId },
  });
  return res.data;
};

export const getUserNotificationSettings = async (userId) => {
  const res = await api.get(`/apis/user_notified/list`, {
    params: { user_id: userId },
  });
  return res.data;
};

// export const updateUserNotificationSetting = async (userId, option, value) => {
//   const res = await api.post(`/apis/user_notified`, null, {
//     params: {
//       user_id: userId,
//       option,
//       value,
//     },
//   });
//   return res.data;
// };
export const updateUserNotificationSetting = async (
  userId,
  option,
  value,
  types,
) => {
  const res = await api.post("/apis/user_notified", null, {
    params: {
      user_id: userId,
      option,
      types,
      value,
    },
  });
  return res.data;
};

export const addNotificationMeter = async ({
  user_id,
  weekly,
  monthly,
  meter_id,
  account_name,
  end_date,
  register_number,
}) => {
  const res = await api.post("/apis/notification_meters_main_update", null, {
    params: {
      user_id,
      weekly,
      monthly,
      meter_id,
      account_name,
      end_date,
      register_number,
    },
  });

  return res.data;
};

export const updateNotificationMeter = async ({
  user_id,
  weekly,
  monthly,
  meter_id,
  account_name,
  end_date,
  register_number,
}) => {
  const res = await api.post("/apis/notification_meters_main_update", null, {
    params: {
      user_id,
      weekly,
      monthly,
      meter_id,
      account_name,
      end_date, // we will send "YYYY-MM-DD 00:00:00"
      register_number,
    },
  });

  return res.data;
};

export const deleteNotificationMeter = async ({
  user_id,
  meter_id,
  register_number,
}) => {
  const res = await api.delete("/apis/notification_meters_remove", {
    params: {
      user_id,
      meter_id,
      register_number,
    },
  });

  return res.data;
};

// ✅ Water Usage Report Download API
export const getWaterUsageReport = async ({
  start_date,
  end_date,
  aggregate_on,
}) => {
  const res = await api.get("/apis/water_usage_report", {
    params: {
      report_range: "all",
      start_date,
      end_date,
      aggregate_on,
    },
  });

  return res.data;
};

export const getTotalConsumption = async (timeRange) => {
  const res = await api.get("/apis/all_year_consumption", {
    params: { option: timeRange },
  });
  return res.data;
};

export const getCapacityPlanning = async (unit) => {
  const res = await api.get(`/apis/capactiy`, {
    params: { unit },
  });
  return res.data;
};

export const getAccountBasedMetersList = async (userId) => {
  const res = await api.get("/apis/accountbased_meters_list", {
    params: { user_id: userId },
  });
  return res.data;
};

// ✅ USER SIGNUP
export const signupUser = async (data) => {
  try {
    const res = await api.post("apis/signup", data);
    console.log("Signup Response:", res);
    return res.data;
  } catch (error) {
    console.error("Error signing up user:", error);
    throw error;
  }
};

// ✅ EDIT USER
export const editUser = async (id, data) => {
  try {
    const res = await api.put(`apis/signup/edit/${id}`, data);
    console.log("Edit User Response:", res);
    return res.data;
  } catch (error) {
    console.error("Error editing user:", error);
    throw error;
  }
};
// DELETE USER

export const deleteUser = async (id) => {
  try {
    const res = await api.delete(`apis/delete_user/${id}`);
    console.log("Delete User Response:", res);
    return res.data;
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
};
// ✅ PASSWORD RESET
// ✅ PASSWORD RESET (FIXED)
export const resetUserPassword = async (data) => {
  try {
    const res = await api.post("apis/admin_change_password", data);
    console.log("Reset Password Response:", res);
    return res.data;
  } catch (error) {
    console.error("Error resetting password:", error);
    throw error;
  }
};

// ================= PROFILE SETTINGS APIs =================

//  Get User Profile
export const getUserProfile = async (userId) => {
  const res = await api.get("apis/user_profile", {
    params: { user_id: userId },
  });
  return res.data;
};

//  Get Color Palettes
export const getColorList = async () => {
  const res = await api.get("apis/color/list");
  return res.data;
};

//  Update Profile Details
export const updateUserProfile = async (data) => {
  const res = await api.post("apis/user_edit_profile", data);
  return res.data;
};

//  Change Password
export const changeUserPassword = async (data) => {
  const res = await api.put("apis/change_password", data);
  return res.data;
};

//  Change Email
export const changeUserEmail = async (oldEmail, newEmail) => {
  const res = await api.post("apis/change_email", null, {
    params: {
      old_email: oldEmail,
      email: newEmail,
    },
  });
  return res.data;
};

// Confirm Email OTP
export const confirmUserEmailOtp = async (data) => {
  const res = await api.post("apis/change_email_otp_confirm", data);
  return res.data;
};
/**
 * Fetch anomaly widget summary data
 * @param {string} timeRange - 'last_7_days', 'last_30_days', 'last_90_days', etc.
 */
export const getAnomalySummary = async (timeRange) => {
  const res = await api.get("apis/anomaly_widget_summary", {
    params: {
      time_range: timeRange,
    },
  });
  return res.data;
};

export const getWaterLeak = async (category = "ALL", interval = "Current") => {
  const res = await api.get("/apis/get_water_leak", {
    params: {
      category,
      interval,
    },
  });
  return res.data;
};

// getAnomalyCategories
export const getAnomalyCategory = async () => {
  const res = await api.get("/apis/anoamaly_detection");
  return res.data;
};

// Get Leak Rate List
export const getWaterRate = async (page = 1, perPage = 5) => {
  const response = await api.get(
    `/apis/get_water_rate?page_no=${page}&records_per_page=${perPage}`,
  );
  return response.data;
};
// Add Leak Rate
export const addWaterRate = async (data) => {
  try {
    const response = await api.post("/apis/add_water_rate", data);
    return response.data;
  } catch (error) {
    console.error("Error adding water rate:", error);
    throw error;
  }
};
// Edit Leak Rate
export const editWaterRate = async (id, data) => {
  try {
    const response = await api.put(`/apis/edit_water_rate/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error editing water rate:", error);
    throw error;
  }
};
// Delete Leak Rate
export const deleteWaterRate = async (id) => {
  try {
    const response = await api.delete(`/apis/delete_water_rate/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting water rate:", error);
    throw error;
  }
};

// export const getMaintenanceLogs = async (
//   page = 1,
//   perPage = 5,
//   filters = {},
// ) => {
//   let url = `/apis/leak_maintenance?page=${page}&per_page=${perPage}`;

//   if (filters.option) {
//     url += `&option=${filters.option}`;
//   }

//   if (filters.start_date && filters.end_date) {
//     url += `&start_date=${filters.start_date}&end_date=${filters.end_date}`;
//   }

//   const res = await api.get(url);
//   return res.data;
// };
export const getMaintenanceLogs = async (
  page = 1,
  perPage = 5,
  filters = {},
  recordType = "Maintenance",
) => {
  let url = `/apis/leak_maintenance?page=${page}&per_page=${perPage}`;

  if (recordType) {
    url += `&record_type=${recordType}`;
  }

  if (filters.option) {
    url += `&option=${filters.option}`;
  }

  if (filters.start_date && filters.end_date) {
    url += `&start_date=${filters.start_date}&end_date=${filters.end_date}`;
  }

  const res = await api.get(url);
  return res.data;
};

export const addMaintenanceLog = async (payload) => {
  const res = await api.post("/apis/leak_maintenance", payload);
  return res.data;
};
export const deleteMaintenanceLog = async (id) => {
  const res = await api.delete(`/apis/leak_maintenance/${id}`);
  return res.data;
};
export const updateMaintenanceLog = async (id, payload) => {
  const res = await api.put(`/apis/leak_maintenance/${id}`, payload);
  return res.data;
};
//Temp log API
export const getTempMeterLogs = async (page = 1, perPage = 5, filters = {}) => {
  let url = `/apis/temp_meter?page=${page}&per_page=${perPage}`;

  if (filters.option) {
    url += `&option=${filters.option}`;
  }

  if (filters.start_date && filters.end_date) {
    url += `&start_date=${filters.start_date}&end_date=${filters.end_date}`;
  }

  const res = await api.get(url);
  return res.data;
};
// ADD TEMP METER
export const addTempMeterLog = async (payload) => {
  const res = await api.post("/apis/temp_meter", payload);
  return res.data;
};

// UPDATE TEMP METER
export const updateTempMeterLog = async (id, payload) => {
  const res = await api.put(`/apis/temp_meter/${id}`, payload);
  return res.data;
};

// DELETE TEMP METER
export const deleteTempMeterLog = async (id) => {
  const res = await api.delete(`/apis/temp_meter/${id}`);
  return res.data;
};

//Drag and drop Home
export const getWidgetLayout = async () => {
  const res = await api.get("/apis/get_widget");
  return res.data;
};

export const editWidgetLayout = async (payload) => {
  const res = await api.put("/apis/edit_widget", payload);
  return res.data;
};
export const getMeterLocationList = async (active) => {
  const res = await api.get("apis/meter_location_list", {
    params: {
      active: active,
    },
  });
  return res.data;
};
// edit account override name
// ✅ EDIT OVERRIDE NAME
export const editOverrideName = async (id, data) => {
  try {
    const res = await api.patch(`apis/account/overide_name/edit/${id}`, data);
    console.log("Edit Override Name Response:", res);
    return res.data;
  } catch (error) {
    console.error("Error editing override name:", error);
    throw error;
  }
};
/**
 * Fetch combined list of accounts, meters, and categories
 */
// services/index.js

const buildWaterUsagePayload = (filters = {}) => {
  const OPTION_MAPPING = {
    D: "Past Day",
    W: "Past Week",
    "1M": "Past Month",
    "3M": "Past 3 Months",
    YTD: "Custom",
    "1Y": "Past Year",
  };

  const normalizeInterval = (interval) => {
    if (interval === "Hour" || interval === "Hours") return "Hours";
    if (interval === "Day" || interval === "Days") return "Days";
    if (interval === "Week" || interval === "Weeks") return "Weeks";
    return "Days";
  };

  const isCustom =
    filters.option === "Custom" ||
    filters.mode === "Custom" ||
    filters.chip === "YTD";

  const payload = {
    accounts: filters.accounts || filters.account || [],
    meter_ids: filters.meter_ids || filters.meter || [],
    codes: filters.codes || filters.category || [],
    option: isCustom
      ? "Custom"
      : filters.option || OPTION_MAPPING[filters.chip] || "Past Month",
    interval: normalizeInterval(filters.interval),
    meter_status: filters.meter_status || "active",
  };

  if (isCustom) {
    payload.start_date = filters.start_date || filters.start;
    payload.end_date = filters.end_date || filters.end;
  }

  return payload;
};

export const getAccountMeterCategoryList = async (payload = {}) => {
  // Ensure the body has the structure the API expects, even if empty
  const body = {
    accounts: payload.accounts || [],
    meter_ids: payload.meter_ids || [],
    codes: payload.codes || [],
    meter_status: payload.meter_status || "active",
  };

  // Pass 'body' as the second argument to api.post
  const res = await api.post("apis/account_meter_category_list", body);
  return res.data;
};

export const getWaterUsageKPI = async (filters = {}) => {
  const payload = {
    accounts: filters.account_ids || filters.accounts || [],
    meter_ids: filters.meter_ids || [],
    codes: filters.codes || [],
    option: filters.option || "Past Month",
    interval: filters.interval === "Day" ? "Days" : filters.interval || "Days",
    meter_status: filters.meter_status || "active",
  };

  if (filters.option === "Custom") {
    payload.start_date = filters.start_date;
    payload.end_date = filters.end_date;
  }

  const res = await api.post("/apis/water/usage_kpi_new", payload);

  return res.data;
};

/**
 * Fetch Ranked Meters by Flow
 */

// export const getMetersByFlow = async (filters = {}) => {
//   const payload = buildWaterUsagePayload(filters);

//   const res = await api.post("/apis/water/meter_by_flow", payload);
//   return res.data;
// };
// Inside your services/index.js file
export const getMetersByFlow = async (filters = {}) => {
  const payload = buildWaterUsagePayload(filters);

  // MANUALLY ATTACH THE TOGGLE PARAMETER HERE BEFORE SENDING
  if (filters.meter_all !== undefined) {
    payload.meter_all = filters.meter_all;
  }

  const res = await api.post("/apis/water/meter_by_flow", payload);
  return res.data;
};
export const getDailyHourlyTrend = async (filters = {}) => {
  const payload = buildWaterUsagePayload(filters);

  const res = await api.post("/apis/water/usage/trend_analytics", payload);
  return res.data;
};


export const getDailyHourlyTrendData = async (filters = {}) => {
  const payload = buildWaterUsagePayload(filters);
  // Endpoint: /apis/water/usage/trend_analytics/daily_hourly
  const res = await api.post(
    "/apis/water/usage/trend_analytics/daily_hourly",
    payload,
  );
  return res.data;
};

export const getWeeklyTrendData = async (filters = {}) => {
  const payload = {
    ...buildWaterUsagePayload(filters),
    res_format: "only_daily", // Hardcoded payload requirement for weekly
  };
  // Endpoint: /apis/water/usage/trend_analytics/weekly
  const res = await api.post(
    "/apis/water/usage/trend_analytics/weekly",
    payload,
  );
  return res.data;
};
/**
 * Fetch Historical Max and Year-over-Year data
 * @param {Object} filters - Filter object containing accounts, meter_ids, codes, etc.
 */
export const getWeeklyTrendHistorical = async (filters = {}) => {
  const payload = {
    accounts: filters.accounts || filters.account || [],
    meter_ids: filters.meter_ids || filters.meter || [],
    codes: filters.codes || filters.category || [],
    option: filters.option || "Past Month",
    interval: "Days",
    res_format: "only_daily", // Required as per your requirement
  };

  if (payload.option === "Custom") {
    payload.start_date = filters.start_date || filters.start;
    payload.end_date = filters.end_date || filters.end;
  }

  const res = await api.post("/apis/water/usage/trend_analytics/weekly/historical", payload);
  return res.data;
};

export const getWaterUsageBreakdown = async (filters = {}) => {
  const payload = {
    accounts: filters.accounts || filters.account_ids || [],
    meter_ids: filters.meter_ids || [],
    codes: filters.codes || [],
    option: filters.option || "Past Month",
    interval:
      filters.interval === "Day"
        ? "Days"
        : filters.interval === "Hour"
          ? "Hours"
          : filters.interval === "Week"
            ? "Weeks"
            : filters.interval || "Days",
    meter_status: filters.meter_status || "active",
  };

  if (payload.option === "Custom") {
    payload.start_date = filters.start_date;
    payload.end_date = filters.end_date;
  }

  const res = await api.post("/apis/water/usage_breakdown_new", payload);

  return res.data;
};

export const getWaterUsageTrendPlots = async (payload = {}) => {
  const body = {
    ...payload,
    meter_status: payload.meter_status || "active",
  };

  const response = await api.post("/apis/water/usage/trend_plots", body);
  return response;
};

// Drought Dashboard Services

export const getDroughtSummary = async ({ from_date, to_date }) => {
  const res = await api.get("/apis/drought/summary", {
    params: {
      from_date,
      to_date,
    },
  });

  return res.data;
};

export const getDroughtTopOffenders = async () => {
  const res = await api.get("/apis/drought/top-offenders");
  return res.data;
};

export const getDroughtViolationsByDay = async ({ from_date, to_date }) => {
  const res = await api.get("/apis/drought/violations-by-day", {
    params: {
      from_date,
      to_date,
    },
  });

  return res.data;
};

export const getDroughtViolationsByHour = async ({ from_date, to_date }) => {
  const res = await api.get("/apis/drought/violations-by-hour", {
    params: {
      from_date,
      to_date,
    },
  });

  return res.data;
};

export const getDroughtRateCodeSplit = async ({ from_date, to_date }) => {
  const res = await api.get("/apis/drought/rate-code-split", {
    params: {
      from_date,
      to_date,
    },
  });

  return res.data;
};

export const getDroughtIrrigationImpact = async ({ from_date, to_date }) => {
  const response = await api.get("/apis/drought/irrigation-impact", {
    params: {
      from_date,
      to_date,
    },
  });

  return response.data;
};

export const getDroughtRecentEvents = (params) => {
  return api.get("/apis/drought/recent-events", { params });
};

export const getDroughtMapLocations = (params) => {
  return api.get("/apis/drought/map-locations", { params });
};

export const getDroughtTrendAnalysis = async (range) => {
  const response = await api.get("/apis/drought/trend-analysis", {
    params: { range },
  });

  return response.data;
};

export const getNewMeterList = async () => {
   return api.get("/apis/meter_new_list");
};
export const getCustomWeeklyTrend = async (payload) => {
  const res = await api.post("/apis/water/usage/trend_analytics/custom_weekly", payload);
  return res.data;
};
